import {configureAppStore} from './configureAppStore';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
const initialState = {};

export const store = configureAppStore(initialState);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch: () => AppDispatch = useDispatch // Export a hook that can be reused to resolve types
